import { ChartOptions } from './analytics.model';



/**
 * Stat Counder Data
 */
 const statData = [{
    title: 'Users',
    value: 28.05,
    icon: 'users',
    persantage: '16.24',
    profit: 'up'
  }, {
      title: 'Sessions',
      value: 97.66,
      icon: 'activity',
      persantage: '3.96',
      profit: 'down'
  }, {
      title: 'Avg. Visit Duration',
      value: 3.40,
      icon: 'clock',
      persantage: '0.24',
      profit: 'down'
  }, {
      title: 'Bounce Rate',
      value: 33.48,
      icon: 'external-link',
      persantage: '7.05',
      profit: 'up'
  }
];

/**
 * Top Selleing
 */
 const TopPages = [
    {
        page: "/themesbrand/skote-25867",
        active: '99',
        users: '25.3',
    },
    {
        page: "/dashonic/chat-24518",
        active: '86',
        users: '22.7',
    },
    {
        page: "/skote/timeline-27391",
        active: '64',
        users: '18.7',
    },
    {
        page: "/themesbrand/minia-26441",
        active: '53',
        users: '14.2',
    },
    {
        page: "/dashon/dashboard-29873",
        active: '33',
        users: '12.6',
    },
    {
        page: "/doot/chats-29964",
        active: '20',
        users: '10.9',
    },
    {
        page: "/minton/pages-29739",
        active: '10',
        users: '07.3',
    }
];

export { statData, TopPages };
